import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState, createContext, useContext, useEffect } from 'react';
import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import Metrics from '@adobe/exc-app/metrics';

// eslint-disable-next-line @typescript-eslint/no-empty-function
var eimContext = /*#__PURE__*/createContext([{}, function () {
  return null;
}]);
function EimProvider(_ref) {
  var children = _ref.children,
      serviceName = _ref.serviceName,
      sandboxName = _ref.sandboxName,
      sandboxType = _ref.sandboxType,
      orgId = _ref.orgId,
      userId = _ref.userId;

  var _useState = useState({
    serviceName: serviceName,
    sandboxName: sandboxName,
    sandboxType: sandboxType,
    orgId: orgId,
    userId: userId
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  return /*#__PURE__*/React.createElement(eimContext.Provider, {
    value: [state, setState]
  }, children);
}

/**
 *
 * @param state {EimProviderState}  state defined in the EIM provider, in case that is needed (not used in most of the cases)
 * @param namespace {string} event namespace
 * @param eventName {string} event specific name
 * @param props {Metric} data bag
 */
var triggerLogEvent = function () {
  var namespace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var eventName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var metrics = Metrics.create(namespace);
  metrics.log(eventName, props);
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getCommonEventProps = function (state) {
  var sandboxName = state.sandboxName,
      sandboxType = state.sandboxType,
      groupId = state.orgId,
      capability = state.serviceName,
      userId = state.userId;
  return {
    sandboxName: sandboxName,
    sandboxType: sandboxType,
    groupId: groupId,
    capability: capability,
    userId: userId
  };
};

var getRecentsEvent = function (state, _ref) {
  var objectAction = _ref.action,
      noun = _ref.objectType,
      objectId = _ref.id,
      objectName = _ref.name;
  return _objectSpread$1(_objectSpread$1({}, getCommonEventProps(state)), {}, {
    objectId: objectId,
    objectName: objectName,
    redirectUrl: window.location.href,
    noun: noun,
    clickTimestamp: new Date().getTime(),
    objectAction: objectAction
  });
};

var triggerRecentsEvent = function (state, props) {
  var namespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'quarry.recents.eim';
  var metrics = Metrics.create(namespace);
  metrics.recent("".concat(namespace, ".event"), getRecentsEvent(state, props));
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function useEim() {
  var state;
  var setState;

  try {
    var _useContext = useContext(eimContext);

    var _useContext2 = _slicedToArray(_useContext, 2);

    state = _useContext2[0];
    setState = _useContext2[1];
  } catch (e) {
    console.warn("there is no eim-context-provider accessible to the component, some of the functionality will not be available");
  }

  return {
    triggerEimEvent: function triggerEimEvent(metricProps) {
      return triggerRecentsEvent(state, metricProps);
    },
    triggerLogEvent: function triggerLogEvent$1(namespace, eventName, metricProps) {
      return triggerLogEvent(state, namespace, eventName, metricProps);
    },
    setOrgId: function setOrgId(orgId) {
      return setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          orgId: orgId
        });
      });
    },
    setUserId: function setUserId(userId) {
      return setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          userId: userId
        });
      });
    },
    setSandboxName: function setSandboxName(sandboxName) {
      return setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          sandboxName: sandboxName
        });
      });
    },
    setSandboxType: function setSandboxType(sandboxType) {
      return setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          sandboxType: sandboxType
        });
      });
    },
    setServiceName: function setServiceName(serviceName) {
      return setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          serviceName: serviceName
        });
      });
    }
  };
}

function withEim(WrappedComponent) {
  var displayName = WrappedComponent.displayName || WrappedComponent.name || "Component";

  var ComponentWithEim = function (props) {
    var eim = useEim();
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
      eim: eim
    }, props));
  };

  ComponentWithEim.displayName = "withEim".concat(displayName);
  return ComponentWithEim;
}

/**
 * Parameters for the useAdoption hook
 * @hidden
 */

/**
 * Hook used by the quarry team in order to track their components adoption
 *
 * @example
 * ```typescript
 * import packageJson from '{here the path to you package.json}'
 *
 * function Component () {
 * ...
 *  useAdoption({name: packageJson.name, version: packageJson.version});
 * }
 * ```
 * **Signature:**
 * @param {UseAdoptionParams} params set of values to be sent to EIM for Log events
 * @param {string} params.name  name of the component to be tracked
 * @param {string} params.version  version of the component to be tracked
 * @hidden
 */
function useAdoption() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    name: '',
    version: ''
  },
      name = _ref.name,
      version = _ref.version;

  var indexableWindow = window;

  if (indexableWindow['exc-module-runtime']) {
    var _useEim = useEim(),
        triggerLogEvent = _useEim.triggerLogEvent;

    useEffect(function () {
      triggerLogEvent('quarry', 'quarry.usage', {
        event: "".concat(name, ":").concat(version)
      });
    }, []);
  }
}

export { EimProvider, eimContext, useAdoption, useEim, withEim };
